// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as WrappedPie from "./WrappedPie.bs.js";
import * as WrappedSectionHeader from "./WrappedSectionHeader.bs.js";

function WrappedPlaystyle(Props) {
  var tierDistribution = Props.tierDistribution;
  var starDistribution = Props.starDistribution;
  var levelDistribution = Props.levelDistribution;
  var levelDistribution$1 = Belt_Array.slice(levelDistribution, 6, 3);
  var totTierDistribution = Belt_Array.reduce(tierDistribution, 0, (function (acc, v) {
          return acc + v | 0;
        }));
  var tierDistribution$1 = Belt_Array.reverse(Belt_Array.mapWithIndex(tierDistribution, (function (idx, v) {
              return [
                      String(idx + 1 | 0) + "g",
                      Global.f(v) / Global.f(totTierDistribution) * 100
                    ];
            })));
  var totStarDistribution = Belt_Array.reduce(starDistribution, 0, (function (acc, v) {
          return acc + v | 0;
        }));
  var starDistribution$1 = Belt_Array.reverse(Belt_Array.mapWithIndex(starDistribution, (function (idx, v) {
              return [
                      String(idx + 1 | 0) + "★",
                      Global.f(v) / Global.f(totStarDistribution) * 100
                    ];
            })));
  var totLevelDistribution = Belt_Array.reduce(levelDistribution$1, 0, (function (acc, v) {
          return acc + v | 0;
        }));
  var levelDistribution$2 = Belt_Array.reverse(Belt_Array.mapWithIndex(levelDistribution$1, (function (idx, v) {
              return [
                      "Lvl " + String(idx + 7 | 0),
                      Global.f(v) / Global.f(totLevelDistribution) * 100
                    ];
            })));
  return React.createElement("div", {
              className: "pt-16"
            }, React.createElement(WrappedSectionHeader.make, {
                  title: "Playstyle"
                }), React.createElement("div", {
                  className: "flex justify-between"
                }, React.createElement("div", undefined, React.createElement("div", {
                          className: "text-center pb-1 font-montserrat font-medium text-lg"
                        }, "Unit Cost"), React.createElement(WrappedPie.make, {
                          data: tierDistribution$1
                        })), React.createElement("div", undefined, React.createElement("div", {
                          className: "text-center pb-1 font-montserrat font-medium text-lg"
                        }, "Unit Star level"), React.createElement(WrappedPie.make, {
                          data: starDistribution$1
                        })), React.createElement("div", undefined, React.createElement("div", {
                          className: "text-center pb-1 font-montserrat font-medium text-lg"
                        }, "Level"), React.createElement(WrappedPie.make, {
                          data: levelDistribution$2
                        }))));
}

var make = WrappedPlaystyle;

export {
  make ,
  
}
/* react Not a pure module */
